import { render, staticRenderFns } from "./digital-shelf.vue?vue&type=template&id=386aadbd"
import script from "./digital-shelf.vue?vue&type=script&lang=js"
export * from "./digital-shelf.vue?vue&type=script&lang=js"
import style0 from "../core/icons.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./digital-shelf.less?vue&type=style&index=1&prod&lang=less&external"
import style2 from "./shortcut.less?vue&type=style&index=2&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports